import { Store } from '@ngrx/store';
import { Injectable, Inject, EventEmitter } from '@angular/core';

// Translation
import { TRANSLATIONS, LANGUAGES, ADMIN_LANGUAGES } from '../translation';

// Observable
import { Observable } from 'rxjs/Observable';

// Reducers & Actions
import * as fromAuth from '../../auth/reducers';
import * as fromCore from '../../core/reducers';
import * as UIActions from '../../core/actions/ui.actions';

@Injectable()
export class TranslationService {

  // Private variables
  private PLACEHOLDER = '%';
  private _currentLang: string;
  private _defaultLang: string = 'en-US';

  // Private observables
  private user$: Observable<any> = this.authStore.select(state => state.auth.login.user);

  // get current lang
  public get currentLang() {
    return this._currentLang || this._defaultLang;
  }

  // get current lang short name
  public get currentLangShortName() {
    const i = LANGUAGES.findIndex(value => value.code === this.currentLang);
    return LANGUAGES[i].key;
  }

  // get all the languages availables
  public get langsAvailable() {
    return LANGUAGES;
  }

  // get the admin languages availables
  public get adminLangsAvailable() {
    return ADMIN_LANGUAGES;
  }

  // inject our translations
  constructor(
    private store: Store<fromCore.State>,
    private authStore: Store<fromAuth.State>,
    @Inject(TRANSLATIONS) private _translations: any
  ) { }

  // private performs search
  private findKey(key: string, lang: string = null): string {
    const translation = key.split('.');
    let result = this._translations[lang || this.currentLang];

    for (let i = 0; i < translation.length; i++) {
      if (result[translation[i]]) {
        result = result[translation[i]];
      } else {
        result = key;
        break;
      }
    }

    return result;
  }

  // private perform translation
  public translate(key: string, lang: string = null): string {
    let translation = key;

    if (this._translations[this.currentLang]) {
      translation = this.findKey(translation, lang);
    }

    return translation;
  }

  // set current language
  public use(lang: string): void {
    this._currentLang = lang;
    this.store.dispatch(new UIActions.LanguageChange(lang));

    // Save language by user
    this.user$.first().subscribe(user => {
      localStorage.setItem('csi-user-' + user.email + '-lang', this._currentLang);
    }).unsubscribe();
  }

  // replace placeholders
  public replace(word: string = '', words: string | string[] = '') {
    let translation: string = word;

    const values: string[] = [].concat(words);
    values.forEach((e, i) => {
      translation = translation.replace(this.PLACEHOLDER.concat(<any>i), e);
    });

    return translation;
  }

  // call translation
  public instant(key: string, words?: string | string[]) {
    const translation: string = this.translate(key);

    if (!words) { return translation; }

    return this.replace(translation, words);
  }

}



// WEBPACK FOOTER //
// ./src/app/translation/services/translation.service.ts